import { render, staticRenderFns } from "./Vervalprovinsi.vue?vue&type=template&id=4b475bfb"
import script from "./Vervalprovinsi.vue?vue&type=script&lang=js"
export * from "./Vervalprovinsi.vue?vue&type=script&lang=js"
import style0 from "./Vervalprovinsi.vue?vue&type=style&index=0&id=4b475bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports